import { memo, useMemo, useState } from 'react'

import { ValidationStatus, Validator } from 'core-components/library/validation'

import { BaseNumberInput } from '../baseNumberInput/BaseNumberInput'

import { IValidateNumberInputProps } from './models'

export const ValidateNumberInput = memo<IValidateNumberInputProps>((props) => {
  const [validateStatus, setValidateStatus] = useState<ValidationStatus>(ValidationStatus.Valid)
  const valueDependencies = useMemo(() => {
    if (props.valueDependencies) {
      return props.valueDependencies
    }
    return [props.disabled]
  }, [props.disabled, props.valueDependencies])
  const wrapper = useMemo(
    () =>
      props.value === props.defaultValue && validateStatus === ValidationStatus.Invalid
        ? 'warning'
        : validateStatus === ValidationStatus.Invalid
          ? 'danger'
          : 'normal',
    [props.defaultValue, props.value, validateStatus]
  )

  return (
    <Validator
      value={props.value || ''}
      checkFn={props.checkFn}
      defaultValue={props.defaultValue}
      valueDependencies={valueDependencies}
      field={props.field}
      onChangeValidation={setValidateStatus}
      classes={props.classes?.validatorClasses}
    >
      <BaseNumberInput {...props} classes={props.classes?.inputClasses} wrapper={wrapper} />
    </Validator>
  )
})
